
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'VitalDetail',
  props: ['vitals'],
  data () {
    return {
      patientSummary: {
        name: 'Strawberry Shortcake Jamz',
        birthdate: '01 Jan 1980',
        age: '20',
        location: 'Ward 12',
        hrn: 332211
      },
      admissionDate: new Date().toISOString().substr(0, 10)
    }
  },
  computed: {
    vital: {
      get () {
        return this.vitals
      },
      set (value) {
        this.$emit('updateVital', value)
      }
    }
  }

})
